export const baseURL = process.env.NODE_ENV === "development" ? "/api" : "";
